import React, { useState, useEffect } from "react";
import { CheckboxContainer } from "./index.styled";
import { viewSizeCalculator } from "../../utils";
import { CheckboxLabel } from "../AdvanceFilterComp/index.styled";
import { useFilters } from "../../hooks/useFilters";

const PartnerExclusiveCheckbox = ({ initialState = true, onToggle }) => {
  const [isChecked, setIsChecked] = useState(initialState);
  const { partnerExclusiveFlag, togglePartnerExclusive } = useFilters();

  const handleToggle = () => {
    setIsChecked((prev) => !prev);
    if (onToggle) onToggle(!isChecked);
    togglePartnerExclusive();
  };
  useEffect(() => {
    setIsChecked(partnerExclusiveFlag);
  }, [partnerExclusiveFlag]);
  return (
    <CheckboxContainer isChecked={isChecked}>
      <input
        style={{
          cursor: "pointer",
          accentColor: "#F96250",
          width: viewSizeCalculator(1.063),
          height: viewSizeCalculator(1.063),
        }}
        type="checkbox"
        id={"partnerExclusiveCheckbox"}
        checked={isChecked}
        onChange={handleToggle}
      />
      <CheckboxLabel htmlFor={"partnerExclusiveCheckbox"}>
        Include Partner ESA
      </CheckboxLabel>
    </CheckboxContainer>
  );
};

export default PartnerExclusiveCheckbox;
